// import { useRequest } from '@byted/hooks';
// import { forumUserService } from '@/api/forumUser';

import useSWR from 'swr';
import { useUserInfo } from './useUserInfo';
import { forumUserService } from '@/api/forumUser';
import useBiz from '@/context/useBiz';

// const fetcher = async (pageNo: number) => {
//   const res = await forumUserService.getUserHome();
// };

export const useUserHome = () => {
  const { User } = useUserInfo();
  const biz = useBiz(state => state.biz);
  const { data } = useSWR(
    User ? { url: 'getUserHome', User } : null,
    async ({ User: _User }) => {
      const res = await forumUserService.getUserHome({
        ToUserId: _User?.Id,
        Biz: biz,
      });
      if (res.error) {
        throw new Error();
      }
      return res.data;
    },
  );
  // const {} = useRequest();

  return {
    data,
  };
};
